<template>

  <div class="modal fade" id="AddElementElectriqueModal" tabindex="-1" role="dialog" ref="addElementElectriqueModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="ElementElectrique">
              <div class="modal-content">
                  <div class="modal-header">
                      <h4 class="modal-title">{{ title }}</h4>
                      <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <Form ref="elementElectriqueForm" @submit="AddElementElectrique" :validation-schema="elementElectriqueSchema">
                      <div class="row">
                        
                        <div class="col-md-12 mb-3">
                          <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                              Designation <span class="text-danger">*</span>
                            </label>
                            <Field name="designation" type="text" 
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la désignation"/>
                            <ErrorMessage name="designation" class="text-danger"/>
                          </div>     
                        </div>

                        <div class="col-md-6 mb-3">
                          <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                              Cout <span class="text-danger">*</span>
                            </label>
                            <Field name="cout" type="text" 
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le cout"
                            @keydown="($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()"
                            />
                            <ErrorMessage name="cout" class="text-danger"/>
                          </div>     
                        </div>

                        <div class="col-md-6 mb-3">
                          <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                              Groupe de Taxe <span class="text-danger">*</span>
                            </label>
                            <Field name="groupeTaxe" v-slot="{ field }">
                              <Multiselect 
                                v-model="field.value" 
                                v-bind="field" 
                                contratholder="Rechercher un groupe"
                                :filter-results="false"
                                :min-chars="3" 
                                :resolve-on-load="false" 
                                :delay="0"
                                :searchable="true" 
                                :options-limit="300" 
                                :options=groupeTaxeOption
                                noResultText="Aucun enregistrement trouvé" 
                                noOptionsText="Tapez au moins trois caractères" />
                            </Field>
                            <ErrorMessage name="groupeTaxe" class="text-danger" />
                          </div>
                        </div>

                    
                        <button
                          class="btn btn-primary"
                          type="submit">
                          {{ btntext }}
                        </button>
                      </div>
                    </Form>
                  </div>
               
              </div>
          </div>
      </div>
  </template> 
  
  <script lang="ts">
  import { onMounted, ref, watch } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  import ApiService from '@/services/ApiService';
  import { error, hideModal, success } from '@/utils/utils';
  import { ElementElectrique} from '@/models/ElementElectrique';
  import { useRouter } from 'vue-router';
  import AddElementElectriquePage from '@/pages/ElementElectrique/AddElementElectriquePage.vue';
  import { GroupeDeTaxe } from '@/models/GroupeDeTaxe';
  import Multiselect from '@vueform/multiselect';

  export default {
    name: "AddElementElectriqueModal",
    components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
    props:{
      id: {
        type: Number,
        required: true,
        default:0
      },
    },
    emits: ["refreshElementElectriques",'openmodal'],
    setup: (props: any, { emit }: { emit: (event: string, payload?: any) => void }) => {
      const loading = ref<boolean>(false);
      
      const elementElectriqueSchema = Yup.object().shape({
        designation: Yup.string().required('La désignation est obligatoire'),
        cout: Yup.string().required('Le cout est obligatoire'),
        groupeTaxe: Yup.number().required("Le groupe de taxe est obligatoire"),
      });

      const elementElectriquenew = ref(props.id);
      const elementElectriqueForm =  ref<ElementElectrique | null>(null);
      const addElementElectriqueModalRef = ref<null | HTMLElement>(null);
      let elementElectriques= ref<Array<ElementElectrique>>([]);
      const title = ref('Ajouter un element electrique ');
      const btntext = ref('Ajouter');
      const isupdate=ref(false);
      const router = useRouter();
      const groupeTaxeOption = ref<Array<GroupeDeTaxe>>([])
  
      watch(() => props.id , (newValue) => {   
        if (newValue!=0) {
          getElementElectrique(newValue);
          isupdate.value=true;
        }
        btnTitle();
      });
  
   


const  getElementElectrique  = async (id: number) => {
            console.log(id, "Element recupéré")
            return ApiService.get("/elements/" + id)
                .then(({ data }) => {
                    const donnees = data.data;
                    for (const key in donnees) {
                      elementElectriqueForm.value?.setFieldValue(key,
                            (typeof donnees[key] === 'object' && donnees[key] !== null) ? donnees[key].id : donnees[key]
                        );
                    }
                    emit('openmodal', addElementElectriqueModalRef.value);
                })
                .catch(({ response }) => {
                    error(response.data.message)
                });
        }
  
      const btnTitle = async () => {
        if (isupdate.value) {
           title.value = "Modifier element";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter un element";
           btntext.value = "Ajouter";
        }
      }

      onMounted(() => {
        getAllGroupeTaxe();
      });

      const getAllGroupeTaxe = async (page = 1, limi = 10, searchTerm = '') => {
        return ApiService.get(`/all/groupeDeTaxe?page=${page}&limit=${limi}&mot=${searchTerm}&`)
          .then(({ data }) => {
            groupeTaxeOption.value = data.data.data.map( (groupe) => (
              {
                value: `${groupe.id}`,
                label: `${groupe.libelle}`,
              }
            ))
            return groupeTaxeOption.value;
          })
          .catch(({ response }) => {
            error(response.data.message)
        });
      }


  
      const AddElementElectrique = async (values:any, {resetForm}: {resetForm: () => void  }) => {
        values = values as ElementElectrique;
        loading.value = false;
        if(isupdate.value) {
          ApiService.put(`/elements/${values.id}`,values)
          .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              resetForm();
              hideModal(addElementElectriqueModalRef.value);
              isupdate.value=false;
              btnTitle();
              emit("refreshElementElectriques");
              router.push('/liste-element-electrique');
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
        }else{
          ApiService.post("/elements",values)
          .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message)
              resetForm();
              hideModal(addElementElectriqueModalRef.value);
              emit("refreshElementElectriques");
  
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
        }
      }; 
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isupdate.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return {
          elementElectriques, 
          title,btntext, 
          resetValue, 
          elementElectriqueSchema, 
          groupeTaxeOption,
          AddElementElectrique, 
          elementElectriqueForm,
          addElementElectriqueModalRef,
          elementElectriquenew,
         //refreshReligions
      };

    },
  };
  </script>